import {Component} from '@angular/core';
import {Button, ButtonDirective} from "primeng/button";
import {TranslatePipe} from "@ngx-translate/core";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {FormBuilder} from "@components/form-builder/form-builder";
import {BidService} from '@6grain/masofa-monolith-api-client/crop-monitoring/api/bid.service';
import { BidFormData } from './bid-form-data';


@Component({
  selector: 'app-modal-form-edit',
  imports: [
    ButtonDirective,
    TranslatePipe,
    Button,
    FormBuilder,
  ],
  templateUrl: './create-bid-form.component.html',
  styleUrl: './create-bid-form.component.scss',
  standalone: true
})
export class CreateBidFormComponent {
  model: BidFormData;
  _model: BidFormData;
  isLoading = false;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public bidService: BidService
    ) {

      this._model =  {};
      this.model = {} ;

      Object.assign(this.model, this.config.data?.model) ;
      Object.assign(this._model, this.config.data?.model) ;
    }

    save(): void {

      this.isLoading = true;

      this.model.lat = this._model.lat as number;
      this.model.lng = this._model.lng as number;
      this.model.publish = false;
      if (!this.model.cropId){
        delete this.model.cropId;
      }


      this.bidService.cropMonitoringBidCustomCreatePost(this.model)
        .subscribe({
          next: (response) => {
            this.isLoading = false;
            this.ref.close({
              success: true,
              data: response || this.model
            });
          },
          error: (error) => {
            console.error('Update Error:', error);
            this.isLoading = false;
          }
        });
    }

    cancel(): void {
        // Close the dialog without returning data
        this.ref.close();
    }
}
